import styled from '@emotion/styled';
import { tokens, Icon } from '@hotjar/hotsauce';
import { formattedDate } from '@hotjar/heatmaps';

const StyledIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const ScreenshotDate = ({ timestamp }: { timestamp: number }): JSX.Element | null => {
  return (
    <Wrapper>
      <StyledIcon icon="camera" inline />
      {formattedDate(timestamp)}
    </Wrapper>
  );
};
